/**
 * SurveySuccess Component
 * Displays success message after survey submission
 */

import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './SurveySuccess.css';

const SurveySuccess = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    // Countdown timer
    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/leading/dashboard');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  const handleReturnNow = () => {
    navigate('/leading/dashboard');
  };

  return (
    <div className="survey-success-container">
      <div className="survey-success-content">
        <div className="success-icon">
          <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
            <circle cx="40" cy="40" r="40" fill="#10b981"/>
            <path 
              d="M25 40L35 50L55 30" 
              stroke="white" 
              strokeWidth="4" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            />
          </svg>
        </div>
        
        <h1 className="success-title">Thank You!</h1>
        
        <p className="success-message">
          Your survey responses have been successfully submitted.
        </p>
        
        <p className="success-description">
          Your feedback is valuable and will help support leadership development 
          at Gallo. A confirmation email has been sent to your inbox.
        </p>
        
        <div className="success-actions">
          <button 
            onClick={handleReturnNow}
            className="questionnaire-button questionnaire-button-primary"
          >
            Return to Dashboard
          </button>
          
          <p className="auto-redirect-message">
            Automatically redirecting in {countdown} second{countdown !== 1 ? 's' : ''}...
          </p>
        </div>
      </div>
    </div>
  );
};

export default SurveySuccess;
